<template>
  <div class="rj-page-card">
    <el-form inline label-width="70px">
      <el-row :gutter="60" align="center">
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item label="申请单号:">
            <el-input
              v-model.trim="formState.applicationId"
              placeholder="请输入申请单号"
              class="input-width"
              maxlength="20"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item label="合同编号:">
            <el-input
              v-model.trim="formState.contractNum"
              placeholder="请输入合同编号"
              class="input-width"
              maxlength="20"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item label="申请单状态:">
            <el-select
              v-model="formState.status"
              placeholder="请选择申请单状态"
              class="input-width"
              clearable
            >
              <el-option
                v-for="item in changeStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item label="变更类型:">
            <el-select
              v-model="formState.type"
              placeholder="请选择变更类型"
              class="input-width"
              clearable
            >
              <el-option
                v-for="item in changeType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item prop="createByName" label="申请人:">
            <el-select
              v-model="formState.createByName"
              filterable
              remote
              clearable
              reserve-keyword
              class="input-width"
              placeholder="请选择申请人"
              :remote-method="getPersonForName"
              :loading="isSearchPersonLoading"
            >
              <el-option
                v-for="item in personList"
                :key="item.userName"
                :label="item.userName"
                :value="item.userName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item label="供应统筹审批人:" prop="supplyCoordination">
            <el-select
              v-model="formState.supplyCoordination"
              filterable
              remote
              reserve-keyword
              clearable
              class="input-width"
              placeholder="请选择审批人"
              :remote-method="getApprovePersonForName"
              :loading="isSearchApprovePersonLoading"
            >
              <el-option
                v-for="item in approvePersonList"
                :key="item.userName"
                :label="item.userName"
                :value="item.userName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <el-form-item label="申请时间:">
            <el-date-picker
              v-model="startAndEndTime"
              type="daterange"
              start-placeholder="开始日期"
              class="input-width"
              value-format="yyyy-MM-dd"
              end-placeholder="结束日期"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" :xxxl="6">
          <div class="search-buttons">
            <el-button
              :loading="isLoading"
              type="primary"
              @click="handleSearch"
            >
              查询
            </el-button>
            <el-button type="default" :loading="isLoading" @click="handleReset">
              重置
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="export-btns">
      <el-button
        type="primary"
        class="export-btn"
        size="medium"
        :disabled="multipleSelection.length < 1"
        @click="handleBatchExport"
      >
        批量导出
      </el-button>
      <el-button
        class="export-btn"
        size="medium"
        @click="handleExportAll"
      >
        全量导出
      </el-button>
    </div>

    <el-table
      v-loading="isLoading"
      border
      :data="tableData"
      highlight-selection-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="45" align="left" />
      <el-table-column
        prop="applicationId"
        label="申请单号"
        min-width="180"
        align="left"
        show-overflow-tooltip
      >
        <template v-slot:default="{ row }">
          <el-button type="text" @click="handleGoDetail(row)">
            {{ row.applicationId }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="createByName"
        label="申请人"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />

      <el-table-column
        prop="supplyCoordinationAuditUserName"
        label="供应统筹审批人"
        min-width="140"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="countryName"
        label="国家"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="projectName"
        label="项目名称"
        min-width="240"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="saleUserName"
        label="外销"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="deptName"
        label="部门"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="salesRegion"
        label="区域"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="contractNum"
        label="合同编号"
        min-width="160"
        align="left"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="status"
        label="申请状态"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="
          (row, column, cellValue, index) =>
            formatterValue(row, column, changeStatusEnum[cellValue], index)
        "
      />
      <el-table-column
        prop="type"
        label="变更类型"
        min-width="100"
        align="left"
        show-overflow-tooltip
        :formatter="
          (row, column, cellValue, index) =>
            formatterValue(row, column, changeTypeEnum[cellValue], index)
        "
      />
      <el-table-column
        prop="applicationTime"
        label="申请时间"
        min-width="200"
        align="left"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'dateTime')"
      />
      <el-table-column
        label="操作"
        min-width="100"
        align="left"
        fixed="right"
      >
        <template v-slot="{ row }">
          <el-button type="text" size="medium" @click="handleGoLook(row)">
            查看
          </el-button>
          <el-button type="text" size="medium" @click="handleExport(row)">
            导出
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 10px">
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="pageState.pageSize"
        :current-page.sync="pageState.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="pageState.total"
        hide-on-single-page
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  getCeddChangeApplicantAll,
  getCeddChangeApprovedList,
  getCeddChangeApproverAll,
  getOrderBatchExport,
  getExportAll
} from '@/API/international';
import { debounce, downloadBlobFile, formatterValue } from '@/libs/util';

export default {
  name: 'ApprovedList',

  data () {
    return {
      // 搜索表单
      formState: {
        applicationId: '',
        contractNum: '',
        status: '',
        startTime: '',
        endTime: '',
        type: '',
        createByName: '',
        supplyCoordination: ''
      },
      // 下拉数据
      pageState: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      startAndEndTime: [], // 时间选择框的值
      // 下拉loading
      isSearchApprovePersonLoading: false,
      isSearchPersonLoading: false,
      // 表格loading
      isLoading: false,
      // 数据
      tableData: [],
      // 选择的数据
      multipleSelection: [],
      // 下拉数据
      personList: [],
      approvePersonList: []
    };
  },
  watch: {
    startAndEndTime: {
      handler (val) {
        if (val) {
          this.formState.startTime = val[0];
          this.formState.endTime = val[1];
        } else {
          this.formState.startTime = '';
          this.formState.endTime = '';
        }
      },
      deep: true
    }
  },
  computed: {
    changeTypeEnum () {
      return this.changeType.reduce(
        (previousValue, currentValue) => ({
          ...previousValue,
          [currentValue.value]: currentValue.label
        }),
        {}
      );
    },
    changeStatusEnum () {
      return this.changeStatus.reduce(
        (previousValue, currentValue) => ({
          ...previousValue,
          [currentValue.value]: currentValue.label
        }),
        {}
      );
    },
    ...mapState({
      changeType: (state) => state.enumeration.changeType,
      changeStatus: (state) => state.enumeration.changeStatus
    })
  },
  methods: {
    formatterValue,
    handleGoDetail (row) {
      // 详情
      const { href } = this.$router.resolve({
        path: '/expectedDeliveryDateDetail',
        query: {
          applicationId: row.applicationId
        }
      });

      window.open(href);
    },
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
    },
    handleSizeChange (pageSize) {
      this.pageState.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange (current) {
      this.pageState.currentPage = current;
      this.getTableData();
    },
    // 导出
    handleExport (record) {
      const applicationIdList = [record.applicationId];
      this.batchExport(applicationIdList);
    },

    // 批量导出
    handleBatchExport () {
      const applicationIdList = this.multipleSelection.map(
        (item) => item.applicationId
      );
      this.batchExport(applicationIdList);
    },

    // 导出函数
    batchExport (applicationIdList) {
      const params = {
        applicationId: applicationIdList,
        isApproval: true
      };
      getOrderBatchExport(params)
        .then((res) => {
          if (res.data instanceof Blob) {
            downloadBlobFile({
              fileName: decodeURIComponent(
                res.headers['content-disposition'].split('=')[1]
              ),
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              content: res.data
            });
          }
        })
        .then((e) => {
          console.log(e);
        });
    },
    getTableData () {
      this.isLoading = true;
      const params = {
        ...this.formState,
        pageNum: this.pageState.currentPage,
        pageSize: this.pageState.pageSize
      };
      getCeddChangeApprovedList(params)
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.tableData = json.data.list;
            this.pageState.total = json.data.total;
          }
        })
        .catch(() => {
          this.tableData = [];
          this.pageState.total = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleSearch () {
      this.pageState.currentPage = 1;
      this.getTableData();
    },
    handleReset () {
      this.formState.type = '';
      this.formState.status = '';
      this.formState.contractNum = '';
      this.formState.applicationId = '';
      this.formState.startTime = '';
      this.formState.endTime = '';
      this.formState.createByName = '';
      this.formState.supplyCoordination = '';
      this.startAndEndTime = void 0;
      this.pageState.pageSize = 10;
      this.pageState.currentPage = 1;
      this.pageState.total = 0;
      this.multipleSelection = [];
      this.getTableData();
    },
    getPersonForName: debounce(function (userName) {
      this.isSearchPersonLoading = true;
      getCeddChangeApplicantAll(userName)
        .then((result) => {
          let json = result.data;
          if (json.status === '200') {
            this.personList = json.data;
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.isSearchPersonLoading = false;
        });
    }, 200),
    getApprovePersonForName: debounce(function (userName) {
      this.isSearchApprovePersonLoading = true;
      getCeddChangeApproverAll(userName)
        .then((result) => {
          let json = result.data;
          if (json.status === '200') {
            this.approvePersonList = json.data;
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.isSearchApprovePersonLoading = false;
        });
    }, 200),
    handleGoLook (row) {
      const { href } = this.$router.resolve({
        path: '/expectedDeliveryDateDetail',
        query: {
          applicationId: row.applicationId
        }
      });
      window.open(href);
    },
    // 全量导出
    handleExportAll () {
      getExportAll({ ...this.formState })
        .then((resopnse) => {
          downloadBlobFile({
            fileName: decodeURIComponent(
              resopnse.headers['content-disposition'].split('=')[1]
            ),
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            content: resopnse.data
          });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  },
  mounted () {
    this.getTableData();
  }
};
</script>

<style scoped lang="scss">
.form_warp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .el-form-item {
    min-width: 175px;
    width: 25%;
    max-width: 100%;
    font-size: 14px;
  }
}
.search-buttons {
  display: flex;
  justify-content: flex-start;
}
.input-width {
  width: 100%;
}
:deep(.el-form-item) {
  display: flex;
  margin-right: 0;
}
:deep(.el-form-item__content) {
  flex: 1;
}
:deep(.el-table-column--selection) {
  & > .cell {
    padding-left: 10px;
    padding-right: 10px;
  }
}
:deep(.el-form-item__label) {
  text-indent: -50px;
}

.el-range-editor--medium.el-input__inner {
  height: 32px !important;
  padding: 1px 10px !important;
}

.export-btns {
  .export-btn {
    width: 80px;
    height: 30px;
    padding: 0;
    margin: 15px 18px 12px 0;
  }
}

</style>
